import { useCallback } from 'react';
import { getSelectedTab } from 'pages/LandingPage/components/LandingPageHeader/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getInvoiceIdsToSelect, getRowNodeData } from './helpers';
import {
  getIsRowDisabled,
  getIsRowIndeterminate,
  getIsRowSelected,
  getVendorRowData,
  selectInvoices
} from './slice';
import type { CheckboxRendererResult } from './types';
import type { IRowNode } from 'ag-grid-community';

export const useCheckboxRenderer = (node: IRowNode): CheckboxRendererResult => {
  const { key } = node;
  const invoiceData = getRowNodeData(node);
  const dispatch = useAppDispatch();
  const selectedTab = useAppSelector(getSelectedTab);

  const rowLabel = key || invoiceData?.invoiceId || '';

  const isChecked = useAppSelector(
    getIsRowSelected(key, invoiceData?.vendorNo, invoiceData?.invoiceId)
  );
  const isIndeterminate = useAppSelector(getIsRowIndeterminate(key));
  const isDisabled = useAppSelector(
    getIsRowDisabled(key, invoiceData?.vendorNo, invoiceData?.invoiceId)
  );

  const vendorInvoices = useAppSelector(getVendorRowData(key));

  const handleChange = useCallback(
    ({ target: { checked } }: React.ChangeEvent<HTMLInputElement>): void => {
      if (key) {
        const invoiceIdsToSelect = getInvoiceIdsToSelect(
          vendorInvoices,
          checked,
          selectedTab
        );
        dispatch(
          selectInvoices({ invoiceIds: invoiceIdsToSelect, selected: checked })
        );
      } else if (invoiceData?.id) {
        dispatch(
          selectInvoices({ invoiceIds: [invoiceData.id], selected: checked })
        );
      }
    },
    [dispatch, invoiceData, key, selectedTab, vendorInvoices]
  );

  return {
    isDisabled,
    isChecked,
    isIndeterminate,
    rowLabel,
    handleChange
  };
};
